export default "__VITE_ASSET__244b4810__"